import { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { FileText, LogIn } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { PageHero } from "../components/PageHero";
import { JobSeekerOverview, DestinationTabs } from "../components/landing/Overview";
import Vacancies from "../components/landing/Vacancies";
import { Reveal, Overline } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";

export default function EmployeePage() {
  const { t } = useLang();
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, [hash]);

  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="employee-page">
      <Header />

      <PageHero overline={t("employee.overline")} title={t("employee.title")} testid="employee-title" img="/assets/bg-jobseekers.jpg">
        <button data-testid="employee-login-cta" onClick={() => navigate("/employee/login")} className="btn-primary">
          <LogIn className="w-4 h-4" /> {t("employee.cta")}
        </button>
      </PageHero>

      <JobSeekerOverview />

      <section className="py-16 px-6 sm:px-12" data-testid="employee-terms">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-11 h-11 rounded-xl bg-[#E8842C] flex items-center justify-center"><FileText className="w-5 h-5 text-white" /></div>
              <h2 className="font-head font-black text-2xl sm:text-3xl text-[#1B2A4E]">{t("employee.tc_title")}</h2>
            </div>
          </Reveal>
          <div className="space-y-4">
            {t("employee.tc").map((item, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="flex gap-4 items-start card-light p-5" data-testid={`employee-term-${i}`}>
                  <span className="font-head font-black text-[#E8842C] text-lg shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <p className="text-sm text-[#1B2A4E]/75 leading-relaxed">{item}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <div id="jobs"><Vacancies /></div>
      <DestinationTabs ns="jsov" testid="jobseeker-process" />
      <Footer />
    </div>
  );
}
